<template>
    <div class="a3d">
        <div class="file job" @click="toggleJobs(job.jobPathKey, job.sourceFilePathKey)">
            <div style="margin-right:1em;height:1px;">
            </div>
            <div class="file-name-block">
                <div class="file-name" v-if="job.isNested">{{job.nestedJobName}}</div>
                <div class="file-name" v-else>{{job.filename}}</div>
                <div class="file-date">{{job.createdAt | dateFormat}}</div>
            </div>
            <template v-if="!job.parentPathKey">
                <div v-if="!job.isArchived" style="align-self: center;">
                    <button class="a3d btn small inv"
                            :disabled="archivingProcess[job.jobPathKey]"
                            @click.stop.prevent="archiveJob({jobPathKey: job.jobPathKey})">
                        {{archivingProcess[job.jobPathKey] ? 'Archiving...' : 'Archive'}}
                    </button>
                </div>
                <div v-else style="align-self: center;">
                    <button class="a3d btn small inv"
                            :disabled="unarchivingProcess[job.jobPathKey]"
                            @click.stop.prevent="unarchiveJob({jobPathKey: job.jobPathKey})">
                        {{unarchivingProcess[job.jobPathKey] ? 'Unarchiving...' : 'Unarchive'}}
                    </button>
                </div>
            </template>
            <div class="toggleIcon">
                <i class="fa" :class="{'fa-chevron-up': isOpen, 'fa-chevron-down': !isOpen}"></i>
            </div>
        </div>
        <div class="progress" v-if="isLoading || archivingProcess[job.jobPathKey] || unarchivingProcess[job.jobPathKey]">
            <div class="indeterminate"></div>
        </div>
        <!-- <div v-if="Array.isArray(job.jobOutputs) && job.jobOutputs.length === 0 && isOpen" style="margin-left:30px;">
            <div class="job jobout align-right">
                <template v-if="subscription || user.credits.length > 0">
                    <button class="right a3d btn small inv"
                            v-if="job.isNested"
                            @click="createNestedJob(job.jobPathKey)"
                            style="margin-right:0.5em;">Create
                    </button>
                    <button class="right a3d btn small inv"
                            v-else
                            @click="createJob(job.id, job.jobPathKey)"
                            style="margin-right:0.5em;">Create
                    </button>
                </template>
                <button class="right a3d btn small"
                        v-else
                        @click="buymodal"
                        style="margin-right:0.5em;">Buy Subscription</button>
                <button class="right a3d btn small inv"
                        @click="removeJobConfirmation($event, job.sourceFilePathKey, job.jobPathKey)"
                        style="margin-right:0.5em;">Remove
                </button>
            </div>
        </div> -->

        <div v-for="(jobOutput, joI) in job.jobOutputs" :key='joI' v-if="isOpen && job.hasOwnProperty('jobOutputs')" style="margin-left:30px;">
            <div class="job jobout" @click="toggleJobsFiles(joI, jobOutput)">
                <div v-if="compareMode && isHasCost(jobOutput.outputFiles, job)" style="display: flex;">
                    <input type="checkbox"
                        :id="jobOutput.jobOutputPathKey"
                        class="filled-in"
                        @change="toggleJobCompare({jobOutput, job})"
                        :checked="isCheckedToCompare(jobOutput.jobOutputPathKey)"/>
                    <label :for="jobOutput.jobOutputPathKey"></label>
                </div>
                <div style="flex:3;font-size:1.2em;" v-if="subscription || jobOutput.paidfor || job.isNested">
                    {{ jobDescription(jobOutput.analysisId, jobOutput.objectiveId, false) }}
                </div>
                <div class="jobout-buttons nested-row"
                     v-if="jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && (subscription || jobOutput.paidfor) && job.isNested">
                    <div class="jobout-buttons-row">
                        <router-link v-if="job.isNested"
                                     :to="{name: 'ThreeJSViewer', params: { id: jobOutput.id, type: 'output'} }"
                                     class='a3d btn inv small'>
                            View
                        </router-link>
                        <button v-if="isHasCost(jobOutput.outputFiles, job)" @click.stop="showEstimateModal({jobOutput, job})" class="a3d btn inv small">Estimate print costs</button>
                         <button v-if="isHasConfigJson(jobOutput.outputFiles)"
                                    class="a3d btn inv small"
                                    @click.stop="fileDownload($event, {
                                     filename: isHasConfigJson(jobOutput.outputFiles),
                                     sourceFilePathKey: job.sourceFilePathKey,
                                     jobPathKey: job.jobPathKey,
                                     jobOutputPathKey: jobOutput.jobOutputPathKey,
                                     newTab: true
                                   })">Download config</button>
                    </div>
                </div>
                <div class="jobout-buttons"
                     v-if="jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && (jobOutput.paidfor || subscription) && !job.isNested">
                    <div class="jobout-buttons-row"
                         v-if="isHasOutput(jobOutput.outputFiles)">
                        <router-link :to="{name: 'ThreeJSViewer', params: { id: jobOutput.id, type: 'output'} }"
                                     class='a3d btn inv small'>
                            View
                        </router-link>
                        <button v-if="isHasLog(jobOutput.outputFiles)"
                           class="right a3d btn small"
                           @click.stop="fileDownload($event, {
                                     filename: isHasLog(jobOutput.outputFiles),
                                     sourceFilePathKey: job.sourceFilePathKey,
                                     jobPathKey: job.jobPathKey,
                                     jobOutputPathKey: jobOutput.jobOutputPathKey,
                                     newTab: true
                                   })">Download optimization log</button>
                        <button v-if="isHasConfigJson(jobOutput.outputFiles)"
                           class="right a3d btn small"
                           @click.stop="fileDownload($event, {
                                     filename: isHasConfigJson(jobOutput.outputFiles),
                                     sourceFilePathKey: job.sourceFilePathKey,
                                     jobPathKey: job.jobPathKey,
                                     jobOutputPathKey: jobOutput.jobOutputPathKey,
                                     newTab: true
                                   })">Download config</button>
                    </div>
                    <div class="jobout-buttons-row"
                         v-if="isHasOutput(jobOutput.outputFiles)">
                        <router-link :to="{
                                            name: 'ThreeJSViewer',
                                            params: { id: jobOutput.id, type: 'output'},
                                            query: {modifySupports: true}
                                          }"
                                     class="a3d btn inv small">Modify Supports</router-link>
                    </div>
                </div>
                <template v-if="!subscription && !jobOutput.paidfor && !job.isNested">
                    <div style="flex-grow:1;padding-top:1px;margin-left:30px;">
                        <i>{{ jobDescription(jobOutput.analysisId, jobOutput.objectiveId) }}</i>
                        is not yet unlocked.
                    </div>
                    <div style='flex-grow:1;flex-basis:50%;align-self:center'>
                        <button v-if="user.credits.length > 0"
                                class="right a3d btn small inv"
                                @click.stop="unlockJob($event, jobOutput, job)"
                                style="margin-right:0.5em;">Unlock<br>(1 credit)
                        </button>
                        <a v-else @click="buymodal" class="a3d btn small right">Buy Subscription</a>
                    </div>
                </template>
                <div class="toggleIcon" v-if="subscription || jobOutput.paidfor || job.isNested">
                    <i class="fa" :class="{'fa-chevron-up': jobsFilesToggle[joI], 'fa-chevron-down': !jobsFilesToggle[joI]}"></i>
                </div>
            </div>
            <template v-if="jobsFilesToggle[joI] && (subscription || jobOutput.paidfor || job.isNested)">
                <div v-if="jobOutput.outputFiles && jobOutput.outputFiles.length > 0">
                    <div v-for="(outputFile, ofI) in jobOutput.outputFiles" :key='ofI'
                         v-if='!outputFile.name.match(/\.json$/)' style="margin-left:40px">
                        <div class="job jobout jobfile"
                             v-if="outputFile.name.match(/^1_.*_0m\.stl$/)
                               && !outputFile.name.match(/_compensated_0m\.stl$/)">
                            <div class="file-name-nested" v-if="outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)">
                                Support Structure Renishaw
                            </div>
                            <div class="file-name-nested" v-else-if="outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)">
                                Support Structure Polymer 
                            </div>
                            <div class="file-name-nested" v-else-if="outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)">
                                Strengthening support
                            </div>
                            <div class="file-name-nested" v-else-if="!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)">
                                Support Structure
                            </div>
                            <div class="button-block right">
                                <dropdown v-if="!outputFile.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/) && !outputFile.name.match(/^1_magicSupp_0m\.stl$/) && !outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)"
                                          @clickout="visibleJobsFilesSupport(joI, false)"
                                          :position="['center', 'top', 'center', 'top']"
                                          :visible="!!(jobsFilesSupportVisible[joI])">
                                    <div class="a3d btn small" @click="visibleJobsFilesSupport(joI, true)">
                                        Download <i class="fa fa-angle-down"></i>
                                    </div>
                                    <div slot="dropdown" class="dialog no-padding">
                                        <aside class="menu">
                                            <ul class="menu-list">
                                                <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                    :key='ofNI'
                                                    v-if="outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/)
                                                      && !outputFileNested.name.match(/^1_.*_(Renishaw|strengthen)_0m\.stl$/)
                                                      && !outputFileNested.name.match(/^1_magicSupp_0m\.stl$/)
                                                      && !outputFileNested.name.match(/^1_polymerSupp.*_0m\.stl$/)
                                                      && !outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)">
                                                    <button class="a3d btn inv small"
                                                       @click="fileDownload($event, {
                                                         filename: outputFileNested.name,
                                                         sourceFilePathKey: job.sourceFilePathKey,
                                                         jobPathKey: job.jobPathKey,
                                                         jobOutputPathKey: jobOutput.jobOutputPathKey
                                                       }); visibleJobsFilesSupport(joI, false)">
                                                        Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                    </button>
                                                </li>
                                            </ul>
                                        </aside>
                                    </div>
                                </dropdown>
                                <div class="a3d btn small nowrap"
                                     v-if="outputFile.name.match(/^1_.*_Renishaw_0m\.stl$/)"
                                     @click="fileDownload($event, {
                                       filename: outputFile.name,
                                       sourceFilePathKey: job.sourceFilePathKey,
                                       jobPathKey: job.jobPathKey,
                                       jobOutputPathKey: jobOutput.jobOutputPathKey
                                     })">
                                  Download STL
                                </div>
                                <div class="a3d btn small nowrap"
                                     v-if="outputFile.name.match(/^1_magicSupp_0m\.stl$/) || outputFile.name.match(/^1_polymerSupp.*_0m\.stl$/)"
                                     @click="fileDownload($event, {
                                       filename: outputFile.name,
                                       sourceFilePathKey: job.sourceFilePathKey,
                                       jobPathKey: job.jobPathKey,
                                       jobOutputPathKey: jobOutput.jobOutputPathKey
                                     })">
                                  Download STL
                                </div>
                                <div class="a3d btn small nowrap"
                                     v-if="outputFile.name.match(/^1_.*_strengthen_0m\.stl$/)"
                                     @click="fileDownload($event, {
                                       filename: outputFile.name,
                                       sourceFilePathKey: job.sourceFilePathKey,
                                       jobPathKey: job.jobPathKey,
                                       jobOutputPathKey: jobOutput.jobOutputPathKey
                                     })">
                                  Download STL
                                </div>
                            </div>
                        </div>
                        <div class="job jobout jobfile"
                             v-else-if="outputFile.name.match(/(.*)_output\.stl$/) || outputFile.name.match(/(.*)_new\.stl$/)">
                            <div class="file-name-nested">
                                Oriented Part
                            </div>
                            <div class="button-block right">
                                <button class="a3d btn inv small"
                                        v-if="isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)"
                                        @click="showEstimateCost($event, {
                                                  filename: 'cost.json',
                                                  sourceFilePathKey: job.sourceFilePathKey,
                                                  jobPathKey: job.jobPathKey,
                                                  jobOutputPathKey: jobOutput.jobOutputPathKey
                                                })">Estimate print costs</button>
                                <dropdown @clickout="visibleJobsFilesPart(joI, false)"
                                          :position="['center', 'top', 'center', 'top']"
                                          :visible="!!(jobsFilesPartVisible[joI])">
                                    <div class="a3d btn small" @click="visibleJobsFilesPart(joI, true)">
                                        Download <i class="fa fa-angle-down"></i>
                                    </div>
                                    <div slot="dropdown" class="dialog no-padding">
                                        <aside class="menu">
                                            <ul class="menu-list">
                                                <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                    :key='ofNI'
                                                    v-if="outputFileNested.name.match(/^(.*)_output\.(?!(txt)$)([^.]{3}$)/) || outputFileNested.name.match(/^.*_new\.[\S]{3}$/)">
                                                    <button class="a3d btn inv small"
                                                       @click="fileDownload($event, {
                                                         filename: outputFileNested.name,
                                                         sourceFilePathKey: job.sourceFilePathKey,
                                                         jobPathKey: job.jobPathKey,
                                                         jobOutputPathKey: jobOutput.jobOutputPathKey
                                                       }); visibleJobsFilesPart(joI, false)">
                                                        Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                    </button>
                                                </li>
                                            </ul>
                                        </aside>
                                    </div>
                                </dropdown>
                            </div>
                        </div>
                        <div class="job jobout jobfile" v-else-if="outputFile.name.match(/plate_[0-9]+\.stl$/)">
                            <div class="file-name-nested">
                                Build plate #{{Number(outputFile.name.match(/plate_([0-9]+)\.stl$/)[1])}}
                            </div>
                            <div class="button-block right">
                                <button class="a3d btn small"
                                        @click="fileDownload($event, {
                                                  filename: outputFile.name,
                                                  sourceFilePathKey: job.sourceFilePathKey,
                                                  jobPathKey: job.jobPathKey,
                                                  jobOutputPathKey: jobOutput.jobOutputPathKey
                                                })">Download</button>
                            </div>
                        </div>
                        <div class="job jobout jobfile" v-else-if="outputFile.name.match(/support[0-9]+\.stl$/)">
                            <div class="file-name-nested">
                                Build plate supports #{{Number(outputFile.name.match(/support([0-9]+)\.stl$/)[1])}}
                            </div>
                            <div class="button-block right">
                                <button class="a3d btn small"
                                        @click="fileDownload($event, {
                                                  filename: outputFile.name,
                                                  sourceFilePathKey: job.sourceFilePathKey,
                                                  jobPathKey: job.jobPathKey,
                                                  jobOutputPathKey: jobOutput.jobOutputPathKey
                                                })">Download</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div style="margin-left:40px">
                        <div class="job jobout job-status">
                            <div class="job-status-message">
                                {{ displayMessage(jobOutput.status) }}
                                <span v-if="jobOutput.status === 'PROCESSING'">{{jobOutput.progress}}%</span>
                            </div>
                            <div class="progress" v-if="jobOutput.status === 'PROCESSING'">
                                <div class="determinate" :style="{width: jobOutput.progress + '%'}"></div>
                            </div>
                            <div class="right">
                                <div style="margin-right:1em;height:1px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="job jobout" v-if="isHasCompensated(jobOutput.outputFiles) && (subscription || jobOutput.paidfor)" @click="toggleJobsFilesCompensated(joI)">
                <div style="flex:3;font-size:1.2em;">
                    {{ jobDescription(jobOutput.analysisId, jobOutput.objectiveId, true) }}
                </div>
                <div class="jobout-buttons">
                    <div class="jobout-buttons-row">
                        <router-link :to="{name: 'ThreeJSViewer', params: { id: jobOutput.id, type: 'output'}, query: {compensated: true}}"
                                     class='a3d btn inv small'>
                            View
                        </router-link>
                    </div>
                </div>
                <div class="toggleIcon">
                    <i class="fa" :class="{'fa-chevron-up': jobsFilesCompensatedToggle[joI], 'fa-chevron-down': !jobsFilesCompensatedToggle[joI]}"></i>
                </div>
            </div>
            <template v-if="jobOutput.outputFiles && jobOutput.outputFiles.length > 0 && jobsFilesCompensatedToggle[joI]">
                <div v-for="(outputFile, ofI) in jobOutput.outputFiles" :key='"compensated" + ofI'
                     v-if='!outputFile.name.match(/\.json$/) && (subscription || jobOutput.paidfor)' style="margin-left:40px">
                    <div class="job jobout jobfile"
                         v-if="outputFile.name.match(/^1_.*_0m\.stl$/) && outputFile.name.match(/_compensated_0m\.stl$/)">
                        <div class="file-name-nested">
                            Support Structure
                        </div>
                        <div class="button-block right">
                            <dropdown @clickout="visibleJobsFilesSupportCompensated(joI, false)"
                                      :position="['center', 'top', 'center', 'top']"
                                      :visible="!!(jobsFilesSupportCompensatedVisible[joI])">
                                <div class="a3d btn small"
                                     @click="visibleJobsFilesSupportCompensated(joI, true)">
                                    Download <i class="fa fa-angle-down"></i>
                                </div>
                                <div slot="dropdown" class="dialog no-padding">
                                    <aside class="menu">
                                        <ul class="menu-list">
                                            <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                :key='ofNI'
                                                v-if="outputFileNested.name.match(/^1_.*_0m\.[\S]{3}$/) && outputFileNested.name.match(/_compensated_0m\.[\S]{3}$/)">
                                                <button class="a3d btn inv small"
                                                        @click="fileDownload($event, {
                                                                  filename: outputFileNested.name,
                                                                  sourceFilePathKey: job.sourceFilePathKey,
                                                                  jobPathKey: job.jobPathKey,
                                                                  jobOutputPathKey: jobOutput.jobOutputPathKey
                                                                }); visibleJobsFilesSupportCompensated(joI, false)">
                                                    Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                </button>
                                            </li>
                                        </ul>
                                    </aside>
                                </div>
                            </dropdown>
                        </div>
                    </div>
                    <div class="job jobout jobfile"
                         v-else-if="outputFile.name.match(/output_compensated\.stl$/)">
                        <div class="file-name-nested">
                            Oriented Part
                        </div>
                        <div class="button-block right">
                            <button class="a3d btn inv small"
                                    v-if="isCost(jobOutput.outputFiles) && outputFile.name.match(/(.*)\.stl$/)"
                                    @click="showEstimateCost($event, {
                                              filename: 'cost.json',
                                              sourceFilePathKey: job.sourceFilePathKey,
                                              jobPathKey: job.jobPathKey,
                                              jobOutputPathKey: jobOutput.jobOutputPathKey
                                            })">Estimate print costs</button>
                            <dropdown @clickout="visibleJobsFilesPartCompensated(joI, false)"
                                      :position="['center', 'top', 'center', 'top']"
                                      :visible="!!(jobsFilesPartCompensatedVisible[joI])">
                                <div class="a3d btn small" @click="visibleJobsFilesPartCompensated(joI, true)">
                                    Download <i class="fa fa-angle-down"></i>
                                </div>
                                <div slot="dropdown" class="dialog no-padding">
                                    <aside class="menu">
                                        <ul class="menu-list">
                                            <li v-for="(outputFileNested, ofNI) in jobOutput.outputFiles"
                                                :key='ofNI'
                                                v-if="outputFileNested.name.match(/output_compensated\.[\S]{3}$/)">
                                                <button class="a3d btn inv small"
                                                   @click="fileDownload($event, {
                                                             filename: outputFileNested.name,
                                                             sourceFilePathKey: job.sourceFilePathKey,
                                                             jobPathKey: job.jobPathKey,
                                                             jobOutputPathKey: jobOutput.jobOutputPathKey
                                                           }); visibleJobsFilesPartCompensated(joI, false)">
                                                    Download {{outputFileNested.name.slice(-3).toUpperCase()}}
                                                </button>
                                            </li>
                                        </ul>
                                    </aside>
                                </div>
                            </dropdown>
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="job.nestedJobs" v-for="jobNested in job.nestedJobs" :key="jobNested.id">
                <job-output :job="jobNested" :compare-mode="compareMode"></job-output>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import JobOutput from './JobOutput.vue'
  import errorHandling from '../../mixins/errorHandling'
  import filesOutput from '../../mixins/filesOutput'
  import dropdown from 'vue-my-dropdown'

  export default {
    components: {
      JobOutput,
      dropdown
    },
    name: 'JobOutput',
    props: ['job', 'compareMode'],
    mixins: [errorHandling, filesOutput],
    data: () => {
      return {}
    },
    computed: {
      ...mapState([
        'user',
        'gettingFileURL',
        'files',
        'jobs',
        'filesPagination',
        'jobsProgress',
        'filesNested',
        'filesCompare',
        'nestedFilesCompare'
      ]),
      ...mapGetters({
        subscription: 'user/subscriptionExpiration'
      })
    },
    methods: {
      ...mapActions({
        refreshCredits: 'user/refreshCredits'
      }),
      ...mapActions([
        // 'getJobs',
        'getJobOutputs',
        'redeemJob',
        'getDownloadURL',
        'getURLData',
        'setJobToCompare',
        'removeJobFromCompare',
        'setNestedFile'
      ]),
      toggleJobCompare (job) {
        const { jobOutput: { jobOutputPathKey } } = job

        this.isCheckedToCompare(jobOutputPathKey) ? this.removeJobFromCompare(job) : this.setJobToCompare(job)
      },
      isHasCost (outputFiles, job) {
        return this.isCost(outputFiles) && !job.isNested || this.isNestedConfig(outputFiles)
      },
      isCheckedToCompare (jobOutputPathKey) {
        return this.filesCompare[jobOutputPathKey] || this.nestedFilesCompare[jobOutputPathKey]
      },
      showEstimateModal (jobToCompare) {
        this.$store.commit('RESET_COMPARE_DATA')
        this.setJobToCompare(jobToCompare)
        this.$modal.show('estimate-cost', {isCompare: true})
      },
      toggleJobs (jobPathKey, sourceFilePathKey) {
        const { jobOutputs, nestedJobs, isNested } = this.job

        this.isOpen = !this.isOpen
        if (!jobOutputs) {
          this.getOutputs(jobPathKey, sourceFilePathKey)
        }
        if (isNested && nestedJobs[0] && !nestedJobs[0].outputsLoaded) {
          nestedJobs.forEach(nestedJob => {
            const { jobPathKey, sourceFilePathKey } = nestedJob
            this.getOutputs(jobPathKey, sourceFilePathKey)
          })
        }
      },
      getOutputs (jobPathKey, sourceFilePathKey) {
        this.isLoading = !this.isLoading
        this.getJobOutputs({jobPathKey, sourceFilePathKey})
          .then((output) => {
            this.isLoading = !this.isLoading
            if (output.jobOutputs && output.jobOutputs.length > 0) {
              const unfinishedJobs = this.countUnfinishedJobs(output.jobOutputs)
              if (unfinishedJobs > 0) {
                this.getJobsProgress({jobPathKey, sourceFilePathKey})
              }
            }
          })
          .catch((err) => {
            this.isLoading = false
            this.isOpen = false
            this.errorHandling(err)
          })
      },
      toggleJobsFiles (index) {
        this.$set(this.jobsFilesToggle, index, !this.jobsFilesToggle[index])
      },
      toggleJobsFilesCompensated (index) {
        this.$set(this.jobsFilesCompensatedToggle, index, !this.jobsFilesCompensatedToggle[index])
      },
      visibleJobsFilesSupport (index, flag) {
        this.$set(this.jobsFilesSupportVisible, index, flag)
      },
      visibleJobsFilesSupportCompensated (index, flag) {
        this.$set(this.jobsFilesSupportCompensatedVisible, index, flag)
      },
      visibleJobsFilesPart (index, flag) {
        this.$set(this.jobsFilesPartVisible, index, !this.jobsFilesPartVisible[index])
      },
      visibleJobsFilesPartCompensated (index, flag) {
        this.$set(this.jobsFilesPartCompensatedVisible, index, !this.jobsFilesPartCompensatedVisible[index])
      },
      createNestedJob (id) {
        this.$router.push({name: 'NestedCreateById', params: {id}})
      },
      archiveJob (payload) {
        this.$set(this.archivingProcess, payload.jobPathKey, true)
        this.$store.dispatch('_jobs/archiveJob', {jobPathKey: payload.jobPathKey})
          .then(() => {
            payload.isArchived = true
            this.$store.commit('ARCHIVE_JOB', payload)
            this.$set(this.archivingProcess, payload.jobPathKey, false)
          })
          .catch((err) => {
            this.errorHandling(err, () => {
              this.archiveJob(payload)
            })
            this.$set(this.archivingProcess, payload.jobPathKey, false)
          })
      },
      unarchiveJob (payload) {
        this.$set(this.unarchivingProcess, payload.jobPathKey, true)
        this.$store.dispatch('_jobs/unarchiveJob', {jobPathKey: payload.jobPathKey})
          .then(() => {
            payload.isArchived = false
            this.$store.commit('ARCHIVE_JOB', payload)
            this.$set(this.unarchivingProcess, payload.jobPathKey, false)
          })
          .catch((err) => {
            this.errorHandling(err, () => {
              this.unarchiveJob(payload)
            })
            this.$set(this.unarchivingProcess, payload.jobPathKey, false)
          })
      }
    },
    beforeDestroy () {
      if (this.timers.length > 0) {
        this.timers.forEach((timer) => {
          clearTimeout(timer)
        })
      }
    },
    filters: {
      dateFormat: function (value) {
        return new Date(value).toLocaleString({
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    #uploadfile {
        display: none;
    }

    .files-preloader {
        padding: 128px;
    }

    .pagination {
        .active {
            background-color: $btn-color;
        }

        .skip {
            font-weight: bold;
            line-height: 30px;
        }
    }

    .a3d {
        .file {
            margin: 0.5em 0;
            padding: 1em;
            display: inline-flex;
            width: 100%;
            background-color: $bg-gray;
        }
        .jobout {
            margin: 0.5em 0;
            padding: 1em;
            background-color: $bg-gray;
            width: 100%;
            align-items: center;
        }
        .job-status {
            flex-direction: column;
            .job-status-message {
                align-self: flex-start;
            }
        }
        .jobs {
            background-color: $bg-gray;
        }
        .job {
            background-color: #FFFFFF;
            display: flex;
        }
        .align-right {
            justify-content: flex-end;
        }
        .toggleIcon {
            padding-left: 16px;
            cursor: pointer;
            align-self: center;
        }
        .jobout-buttons {
            padding-top:1px;
            margin-left:24px;
            display: flex;
            flex-direction: column;
            flex: 2;

            &.nested-row {
              flex: 4;
            }

            .jobout-buttons-row {
                display: flex;
                flex-direction: row-reverse;
                padding-bottom: 6px;
                .btn {
                    margin: auto 0 auto 6px;
                }
            }
        }
    }

    #files-root {
        height: 100%;
        margin-top: -64px;
        padding-top: 64px;
    }

    #section-body {
        height: 100%;
        margin-top: -120px;
        padding-top: 120px;
        margin-bottom: 0;
        > div {
            height: 100%;
        }

        .row {
            &.flex {
                display: flex;
                justify-content: flex-start;
            }
        }

        .files {
            .upload {
                padding: 0.5em 1em;
                margin-left: 1em;
            }

            .create-nested {
                margin-left: auto;
            }

            .error {
                padding: 0.5em 0 1em 0;
                color: #ff0000;
            }
        }

        .file {
            [type="checkbox"].filled-in + label {
                padding-left: 24px;
            }

            [type="checkbox"].filled-in:checked + label:after {
                border-color: #00BDD1;
                background-color: #00BDD1;
            }
        }

        .file-name-block {
            flex-grow: 1;
            display: flex;
            flex-direction: column;

            .file-name {
                word-break: break-all;
                flex-grow: 1;
                font-size:1.3em;
                font-weight:bold;
                padding-right: 4px;
            }

            .file-date {
                font-size: 14px;
            }
        }

        .file-name-nested {
            flex: 2;
        }

        .button-block {
            display: flex;
            text-align: right;
            min-width: 120px;
            justify-content: flex-end;
            flex: 3;

            .btn {
                margin-left: 4px;

                i {
                    font-size: 0.9rem;
                }
            }

            .menu {
                .btn {
                    width: 100%;
                    margin-bottom: 0!important;
                }
            }
        }
    }

    .remove-modal {
        padding: 20px;
        .row {
            margin-bottom: 0;
        }
        .title {
            font-size: 1.4em;
            text-align: center;
            padding-bottom: 20px;
        }
    }

    @media (max-width: 1400px) {
        #section-body {
            .jobs {
                .jobfile {
                    .button-block {
                        flex-direction: column;

                        .btn {
                            margin-bottom: 4px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 1200px) {
        #section-body {
            .files {
                .button-block {
                    flex-direction: column;

                    .btn {
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }

    @media (max-width: 992px) {
        #section-body {
            .files {
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// JobOutput.vue?3976f7bc